module.exports = __webpack_public_path__ + "img/724957c.png";